import { compose } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton
} from "@material-ui/core";
import React, { Component } from "react";
import CloseIcon from "@material-ui/icons/Close";
import PropTypes from "prop-types";
import { SelectGuestsTable } from "../util/SelectGuestsTable";

const StyledDialogIconButton = styled(IconButton)`
  && {
    position: absolute;
    top: 8px;
    right: 13px;
  }
`;

const PrimaryButton = styled(Button)`
  && {
    background: #2196f3;
    color: white;
    font-size: 17px;
    padding: 0px 12px;
    height: auto;
  }
`;

const SecondaryButton = styled(Button)`
  && {
    background: white;
    color: #2196f3;
    font-size: 17px;
    padding: 0px 12px;
    height: auto;
  }
`;

const HeightSetDialogContent = styled(DialogContent)`
  && {
    height: 400px;
    width: 380px;
  }
`;

export class AddGuestGroupMembersModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedGuests: [],
      isOpen: props.isOpen
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.isOpen && !state.isOpen) {
      return {
        selectedGuests: [],
        isOpen: true
      };
    }
    if (!props.isOpen && state.isOpen) {
      return {
        isOpen: false
      };
    }

    return null;
  }

  handleSelectedGuestsChanged = selectedGuests => {
    this.setState({ selectedGuests });
  };

  saveGuestGroupMembers = () => {
    this.props.save(this.state.selectedGuests);
    this.props.closeModal();
  };

  render() {
    return (
      <Dialog
        id="addGuestGroupMembersModal"
        open={this.props.isOpen}
        onClose={this.props.closeModal}
        aria-labelledby="addGuestGroupMembersModalTitle"
      >
        <DialogTitle id="addGuestGroupMembersModalTitle">
          Add Members
          <StyledDialogIconButton onClick={this.props.closeModal}>
            <CloseIcon id="closeIcon" style={{ fontSize: 22 }} />
          </StyledDialogIconButton>
        </DialogTitle>
        <HeightSetDialogContent>
          <SelectGuestsTable
            guests={this.props.guests}
            onSelectedGuestsChanged={this.handleSelectedGuestsChanged}
          />
          <span style={{ fontSize: 14, fontWeight: 400}}>If you don’t see the guest you’re looking for, please add them as a guest on the Guest Permission screen.</span>
        </HeightSetDialogContent>
        <DialogActions>
          <SecondaryButton onClick={this.props.closeModal}>Cancel</SecondaryButton>
          <PrimaryButton size="medium" onClick={this.saveGuestGroupMembers}>
            Add
          </PrimaryButton>
        </DialogActions>
      </Dialog>
    );
  }
}

AddGuestGroupMembersModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  save: PropTypes.func.isRequired,
  guests: PropTypes.object.isRequired
};

function mapStateToProps() {
  return {};
}

export default compose(
  connect(
    mapStateToProps,
    {}
  )
)(AddGuestGroupMembersModal);
